const steps = [
  { title: "New report" },
  { title: "Drafted" },
  // { title: "Initiated" },
  { title: "Submitted" },
  { title: "Acknowledged" },
  { title: "Approved" },
];

export default steps;
